<div class="step-form">
  <div class="section-label">
    <mat-icon class="section-icon">add_circle_outline</mat-icon>
    <span>Resource Creation Mode</span>
  </div>

  <div class="action-tile-row">
    <div class="action-tile action-tile--selected" tabindex="0" role="presentation" aria-label="On Demand">
      <mat-icon class="tile-icon">flash_on</mat-icon>
      <div class="tile-content">
        <strong>On Demand</strong>
        <p class="tile-desc">A user account (Azure subscription) is provisioned when a participant joins the class for the first time.</p>
      </div>
      <mat-icon class="tile-check">check_circle</mat-icon>
    </div>
  </div>
</div>
